import React, { useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { models } from 'powerbi-client';
import * as menu from "../../assets/menus/darm_menu.js";
import UserContext from '../../components/User_Context.js';
import PowerBIReport from '../components/PowerBIReport.jsx';

const GeneralReport = () => {
    const { reportKey } = useParams();
    const { currentUser } = useContext(UserContext);
    const navigate = useNavigate();
    const instance = process.env.REACT_APP_POWERBI_INSTANCE;

    useEffect(() => {
        if (currentUser && currentUser()) {
            menu.write({ user: currentUser() });
        }
    }, [currentUser]);

    const handleBackToDashboard = () => {
        navigate('/reports');
    };

    return (
        <div className="d-flex flex-column" style={{ height: '100vh' }}>
            
            {/* 1) FIXED HEADER + TOOLBAR (never scrolls) */}
            <header className="bg-white shadow-sm">
                <div className="container-fluid d-flex justify-content-between align-items-center py-4">
                    
                    {/* → breadcrumb navigation */}
                    <div className="d-flex align-items-center">
                        <h5 className="mb-0 me-3">
                            <i className="fa fa-chart-line me-2 text-primary"></i>
                            {reportKey || 'PowerBI Report'}
                        </h5>
                        <span className="badge badge-outline-info">
                            {instance || 'N/A'}
                        </span>
                    </div>
                    
                    {/* → action buttons */}
                    <div className="d-flex gap-3">
                        <a 
                            className="text-primary fs-13" 
                            onClick={handleBackToDashboard} 
                            role="button" 
                            title="Torna alla Dashboard Report"
                        >
                            <i className="fa-solid fa-arrow-left fa-2x"></i>
                        </a>
                    </div>
                </div>
            </header>

            {/* 2) SCROLLABLE CONTENT AREA */}
            <main className="flex-grow-1" style={{ minHeight: 0 }}>
                <PowerBIReport 
                    instance={instance}
                    reportKey={reportKey}
                    settings={{
                        filterPaneEnabled: true,
                        //background: models.BackgroundType.Transparent,
                        navContentPaneEnabled: true
                    }}
                />
            </main>
        </div>
    );
};

export default GeneralReport;
